import axiosClient from "../axiosClient";

const route = "supplier";

export const createSupplier = async (supplierData) => {
  const userId = parseInt(localStorage.getItem("userId"), 10);
  const organizationId = localStorage.getItem("organizationId");

  const response = await axiosClient.post(`/createSupplier`, {
    ...supplierData,
    userId: userId,
    organizationId: organizationId,
  });

  return response;
};

export const editBankSupplier = async (supplierId, updateSupplierFields) => {
  const userId = parseInt(localStorage.getItem("userId"), 10);
  const response = await axiosClient.put(
    `updateSupplier/${supplierId}`,
    updateSupplierFields,
    {
      headers: {
        "User-Id": userId,
      },
    }
  );

  return response;
};

// get suppliers for the bank dropdown
export const getBankSuppliers = async (params) => {
  const response = await axiosClient.get(`${route}/forBank`, {
    params: {
      ...params,
    },
  });

  return response;
};

// get suppliers for the bank suppliers page
export const getBankSuppliersForPage = async (searchParams) => {
  try {
    const response = await axiosClient.get(`${route}/suppliersForBank`, {
      params: {
        ...searchParams,
      },
    });

    return response;
  } catch (error) {}
};
